import React, { useContext } from 'react';
import { Col } from 'react-bootstrap';
import './../Projects/ProjectStyle.css'
import { useNavigate, Link } from 'react-router-dom';
const Project = ({ project }) => {
    const navigate = useNavigate()
    return (
        <Col >
            <div className='border h-100 bg-light shadow'>
                <img src={project.img[0]} alt="" className='w-100 border' height={200} />
                <div className=' my-4 px-4 h-full d-flex flex-column justify-content-between'>
                    <h4 className='text-center'>{project.name}</h4>

                    <div>
                        <p className='text-center text-center'><small className=' text-secondary'>{project.descriptions[0]}</small></p>
                        <p className='text-center fw-bold mt-4'>Tools</p>
                        <small className='text-center'>{project.tools}</small>
                        <div className='mt-3 d-flex gap-3 justify-content-between'>

                            <Link to={`/project/${project._id}`}>Details</Link>
                        </div>
                    </div>
                </div>
            </div>


        </Col>
    );
};

export default Project;